import React, { useState } from "react";
import styles from "./InvitationLists.module.scss";
import DynamicCardRow from "../../../DynamicCardRow/DynamicCardRow";
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { invitationListsTableData as initialData } from "../../../../../views/AdminPortal/dummyData";
import Toggle from "../../../../common/AdminCommonComponents/Toggle/Toggle";

const invitationListData = [
    { title: "Invite Sent", value: 0 },
    { title: "Scheduled Campaigns", value: 0 },
    { title: "Invite Accepted", value: 0 },
].map((item) => ({
    ...item,
    title: item.title.toUpperCase(),
}));

const InvitationLists = () => {
    const [tableData, setTableData] = useState(initialData);

    const handleToggleChange = (index) => {
        setTableData((prevData) =>
            prevData.map((item, i) =>
                i === index ? { ...item, toggleState: !item.toggleState } : item
            )
        );
    };

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Campaign ID",
            selector: (row) => row.campaignId,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Campaign Title",
            selector: (row) => row.campaignTitle,
            center: "true",
            minWidth: "160px",
        },
        {
            name: "Linked Banner",
            cell: (row) => (
                <img src={row.imgSrc} alt="Media Image" className="img-fluid" />
            ),
            center: "true",
            width: "180px",
        },
        {
            name: "Seller Invitations",
            selector: (row) => row.sellerInvitations,
            center: "true",
            minWidth: "160px",
        },
        {
            name: "Seller Participated",
            selector: (row) => row.sellerParticipated,
            center: "true",
            minWidth: "180px",
        },
        {
            name: "Start Date",
            selector: (row) => row.startDate,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "End Date",
            selector: (row) => row.endDate,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Actions",
            cell: (row, index) => (
                <Toggle
                    theme="yellow"
                    checked={row.toggleState}
                    onChange={() => handleToggleChange(index)}
                />
            ),
            center: "true",
            minWidth: "120px",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div className={styles.invitationListsContainer}>
            <div className={styles.overviewWrapper}>
                <h5 className={styles.mainHeading}>Invitation Overview</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow lg={4} md={12} sm={12} cards={invitationListData} />
                </div>
            </div>

            <div className={styles.filterTableWrapper}>
                <h5 className={styles.sectionHeading}>Invitation Lists</h5>
                <DynamicTableFilters
                    componentName={"Invitation Lists"}
                    onApply={handleApply}
                    onClear={handleClear}
                />
                <div className={styles.tableWrapper}>
                    <DynamicDatatable
                        data={tableData}
                        columns={columns}
                        type="gray"
                        pagination
                        highlightOnHover
                        responsive
                    />
                </div>
            </div>
        </div>
    );
};

export default InvitationLists;